module.exports = __webpack_public_path__ + "img/banner03.073132fe.jpg";